import * as React from "react"

import styles from "./ChatBackOffice.module.scss"
import ChatBackOfficeWrapper from "./ChatBackOfficeWrapper.tsx"
import ConversationAiControls from "./ConversationAiControls.tsx"

import { ChannelSort } from "stream-chat"
import { AppFunctions } from "@others/AppFunctions.ts"
import { AppStreamChatGenerics } from "@interfaces/IAppStreamChatGenerics.ts"

import {
	Channel,
	ChannelList,
	Window,
	MessageList,
	MessageInput,
} from "stream-chat-react"

const BACKOFFICE_USER_ID = AppFunctions.getViteEnv(
		"VITE_STREAM_BACKOFFICE_USER_ID"
	),
	filters = { members: { $in: [BACKOFFICE_USER_ID] }, type: "messaging" },
	options = { presence: true, state: true },
	sort = { last_message_at: -1 } as ChannelSort<AppStreamChatGenerics>

interface IChatBackOfficeProps {
	className?: string
}

const ChatBackOffice: React.FC<IChatBackOfficeProps> = (props) => {
	return (
		<div className={`${styles.chat_back_office} ${props.className || ""}`}>
			<ChatBackOfficeWrapper>
				<div className={styles.chat_content}>
					<div className={styles.channel_list_container}>
						<ChannelList
							sort={sort}
							filters={filters}
							options={options}
						/>
					</div>

					<Channel>
						<div className={styles.message_list_container}>
							<ConversationAiControls />

							<Window>
								<MessageList
									messageActions={[
										"edit",
										"delete",
										"quote",
										"react",
										"reply",
									]}
								/>

								<MessageInput />
							</Window>
						</div>
					</Channel>
				</div>
			</ChatBackOfficeWrapper>
		</div>
	)
}

export default React.memo(ChatBackOffice)
